export interface UserPaginationSettings {
  entries: number;
  comments: number;
  profiles: number;
  blogs: number;
}

export interface DefaultUserSettings {
  pagination: UserPaginationSettings;
  disabledDesigns: string[];
}

const defaultUserSettings: DefaultUserSettings = {
  pagination: {
    entries: 10,
    comments: 20,
    profiles: 20,
    blogs: 20
  },
  disabledDesigns: []
};

export default defaultUserSettings;
